import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import GenericListTab from "./../../factories/generic-list-tab";
class ShiftbookPerson extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() {
        return "PersonInternal";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default ShiftbookPerson;